/** SSR 分段耗时观测（本地/测试环境）。日志前缀便于 grep: [SSR-TIMING] */
export const SSR_TIMING_ENABLED = process.env.RUN_NODE_ENV !== 'PRODUCTION'

export const ssrNow = () => Date.now()

export const ssrTimingLog = (scope: string, data: Record<string, unknown>) => {
  if (!SSR_TIMING_ENABLED) return
  console.info(`[SSR-TIMING] ${scope} ${JSON.stringify(data)}`)
}

export const ssrMeasure = async <T>(
  scope: string,
  meta: Record<string, unknown>,
  fn: () => Promise<T>
): Promise<T> => {
  const start = ssrNow()
  try {
    const result = await fn()
    ssrTimingLog(scope, { ...meta, ms: ssrNow() - start, ok: true })
    return result
  } catch (e) {
    ssrTimingLog(scope, { ...meta, ms: ssrNow() - start, ok: false })
    throw e
  }
}
